import { Colors, Images, Metrics, Typography } from "../../resources";
import { ConfigurationType, DensityAccount } from "../../types";
import {
  FlatList,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import React from "react";
import SDivider from "../atoms/SDivider";
import { useSettings } from "../../hooks";

interface IProps {
  accounts: ConfigurationType;
  onCloseModal: (impersonat: boolean) => void;
}

const SModal: React.FC<IProps> = ({ accounts, onCloseModal }) => {
  const { writeSetting } = useSettings();

  const data = Object.keys(accounts)
    .filter((key: string) => key !== DensityAccount.OTHER)
    .map((key: string) => ({
      ...{ name: key },
      ...accounts[key],
    }));

  const renderAccount = ({ item }: { item: any }) => {
    const selectAccount = () => {
      writeSetting({
        impersonate: item.name,
      });
      onCloseModal(false);
    };
    return (
      <TouchableOpacity style={styles.listRow} onPress={selectAccount}>
        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
            width: 40,
            height: 40,
          }}
        >
          <Image
            style={{
              width: 30,
              height: 30,
              resizeMode: "contain",
            }}
            source={{ uri: item.imageUrl ? item.imageUrl : Images.density }}
          />
        </View>
        <Text style={styles.account}>{item.name}</Text>
      </TouchableOpacity>
    );
  };

  return (
    <View style={styles.centeredView}>
      <ScrollView contentContainerStyle={styles.container}>
        <FlatList
          data={data}
          renderItem={renderAccount}
          keyExtractor={(item) => item.name}
          ItemSeparatorComponent={() => <SDivider height={1} width="100%" />}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: 20,
    backgroundColor: Colors.white,
    borderRadius: 5,
    paddingHorizontal: 5,
    alignItems: "center",
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  listRow: {
    height: 50,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  account: {
    ...Typography.headline0,
    paddingHorizontal: Metrics.paddingSmall10,
    textAlignVertical: "center",
    flex: 1,
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
});

export default SModal;
